var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top",style:({background: _vm.themesColor})},[_c('Breadcrumb',{ref:"bread"}),_c('Tenant',{ref:"tenant"}),_c('User-info',{on:{"getThemes":_vm.getThemes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }